import React, { Component } from 'react'
import { Field } from 'redux-form'
import ConfigTimeInput from './TimeInput'

class TimeInput extends Component {
  render() {
    if (this.props.source) {
      return <Field component={ConfigTimeInput} {...this.props} name={this.props.name ? this.props.name : this.props.source} />
    } else {
      return <ConfigTimeInput {...this.props} />
    }
  }
}

export default TimeInput
